import { FaMapMarkedAlt } from "react-icons/fa";
import { useTranslator } from "../../../../context/TranslatorContext";
import { useOrderManagerContext } from "../../context";
import { OrderCard } from "../orderCard";
import { OrdersLoading } from "./loader";
import { CardsContainer, CardsWrapper, RouteButton, RouteContent } from "./style";

export function Orders() {
	const { getText } = useTranslator();
	const { orders, ordersIsLoading, orderIsPrinting, setShowCalculateRoutes } =
		useOrderManagerContext();

	const allPending = orders.filter(
		(item) =>
			item.dsStatus === "A" || (item.dsStatus === "W" && item.dtPgtoOnline !== null),
	);
	const allPreparing = orders.filter((item) => item.dsStatus === "P");
	const allDelivering = orders.filter((item) => item.dsStatus === "E");

	if (ordersIsLoading) return <OrdersLoading />;

	if (orderIsPrinting) return null;
	return (
		<CardsContainer>
			<CardsWrapper>
				<header className="wrapper-header">
					<h2>{getText("order-manager.order-card.pendent")}</h2>
					<span>{`( ${allPending.length} )`}</span>
				</header>
				<div className="wrapper-body">
					{allPending.map((item) => {
						return <OrderCard key={item.idOrcamento} item={item} />;
					})}
				</div>
			</CardsWrapper>
			<CardsWrapper>
				<header className="wrapper-header">
					<h2>{getText("order-manager.order-card.preparing")}</h2>
					<span>{`( ${allPreparing.length} )`}</span>
				</header>
				<div className="wrapper-body">
					{allPreparing.map((item) => {
						return <OrderCard key={item.idOrcamento} item={item} />;
					})}
				</div>
			</CardsWrapper>
			<CardsWrapper>
				<header className="wrapper-header">
					<h2>{getText("order-manager.order-card.delivering")}</h2>
					<span>{`( ${allDelivering.length} )`}</span>
				</header>
				<RouteContent>
					{allDelivering.length > 0 && (
						<RouteButton type="button" onClick={() => setShowCalculateRoutes(true)}>
							<FaMapMarkedAlt className="icon" />
							{getText("order-manager.top-bar.calculate-route")}
						</RouteButton>
					)}
				</RouteContent>
				<div className="wrapper-body">
					{allDelivering.map((item) => {
						return <OrderCard key={item.idOrcamento} item={item} />;
					})}
				</div>
			</CardsWrapper>
		</CardsContainer>
	);
}
